<template>
    <BaseLink
        :class="$style.button_override"
        data-interface-target="steam-games-header-button"
        :to="{ name: ROUTE_NAMES.STEAM_GAMES }"
    >
        <img
            :class="$style.icon"
            :src="SteamImg"
            alt=""
        />
        <Typography
            type="caption"
            size="all-caps"
            semibold
            :class="$style.label"
        >
            {{ $tr('header.steamGames') }}
        </Typography>
    </BaseLink>
</template>

<script setup lang="ts">
import BaseLink from '@/components/BaseLink.vue'
import Typography from '@/components/Typography.vue'
import { ROUTE_NAMES } from '@/router/constants'

import SteamImg from './images/steam.svg'
</script>

<style module>
.button_override {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 16px 4px 4px;
    border-radius: 1000px;
    background: var(--carbon-400);
    transition: box-shadow 0.3s;
}

.button_override:hover,
.button_override:focus {
    box-shadow: 0 0 30px 0 rgba(163, 109, 253, 0.64) inset;
    outline: 0.5px solid var(--purple-300);
}

.icon {
    width: 48px;
    height: 48px;
}

.label {
    width: min-content;
    font-size: 11px;
    line-height: 1.06;
    letter-spacing: 0.33px;
    color: #b4bacb;
}
</style>
